/* Make an authenticated API request with cookies */
export const apiRequest = async (endpoint: string, options: RequestInit & { params?: Record<string, any> } = {}): Promise<Response> => {
  const { params, ...fetchOptions } = options;

  let url = endpoint;

  if (params && Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) searchParams.append(key, String(value));
    });
    url += (endpoint.includes('?') ? '&' : '?') + searchParams.toString();
  }

  const defaultOptions: RequestInit = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(url, { ...defaultOptions, ...fetchOptions });
};

/* Make a GET request with authentication */
export const apiGet = async (endpoint: string, params: Record<string, any> = {}): Promise<Response> => {
  return apiRequest(endpoint, { method: 'GET', params });
};

/* Make a POST request with authentication */
const postHeaderDefaults = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};
export const apiPost = async (endpoint: string, data?: any, newHeaders: RequestInit['headers'] = postHeaderDefaults, extraOptions: RequestInit = {}): Promise<Response> => {
  const options = {
    method: 'POST',
    headers: {
      ...newHeaders,
    },
    body: data ? JSON.stringify(data) : undefined,
    ...extraOptions,
  };
  return apiRequest(endpoint, options);
};

/* Make a PATCH request with authentication */
export const apiPatch = async (endpoint: string, data?: any): Promise<Response> => {
  return apiRequest(endpoint, {
    method: 'PATCH',
    body: data ? JSON.stringify(data) : undefined,
  });
};

/* Make a DELETE request with authentication */
export const apiDelete = async (endpoint: string, data?: any): Promise<Response> => {
  return apiRequest(endpoint, {
    method: 'DELETE',
    body: data ? JSON.stringify(data) : undefined,
  });
};
